import * as React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "recompose";
import { Grid } from "semantic-ui-react";
import { withAuthorization } from "../../components/Session/withAuthorization";
import ListOrganizations from "../../components/Organizations/ListOrganizations";

const OrganizationsComponent = ({
  authUser,
  orgId,
  history,
}: {
  [key: string]: any;
}) => (
  <Grid textAlign="center" className="signin-page">
    <Grid.Column style={{ maxWidth: 800 }}>
      <ListOrganizations authUser={authUser} orgId={orgId} history={history} />
    </Grid.Column>
  </Grid>
);

const mapStateToProps = (state: any) => ({
  authUser: state.sessionState.authUser,
  orgId: state.sessionState.orgId,
});

const authCondition = (authUser: any) => !!authUser;

const Organizations = compose(
  withAuthorization(authCondition),
  connect(mapStateToProps)
)(withRouter(OrganizationsComponent));

export default Organizations;



// WEBPACK FOOTER //
// ./src/containers/Organizations/index.tsx